/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EnableMaintenanceModeRequestDto,
  ErrorResponseOfPtw100BadRequestException,
  ErrorResponseOfPtw100ForbiddenException,
  ErrorResponseOfPtw100InternalServerException,
  ErrorResponseOfPtw100MaintenanceModeException,
  ErrorResponseOfPtw100UnauthorizedException,
  MaintenanceModeInfo,
  SystemInfoDto,
} from '../models/index';
import {
    EnableMaintenanceModeRequestDtoFromJSON,
    EnableMaintenanceModeRequestDtoToJSON,
    ErrorResponseOfPtw100BadRequestExceptionFromJSON,
    ErrorResponseOfPtw100BadRequestExceptionToJSON,
    ErrorResponseOfPtw100ForbiddenExceptionFromJSON,
    ErrorResponseOfPtw100ForbiddenExceptionToJSON,
    ErrorResponseOfPtw100InternalServerExceptionFromJSON,
    ErrorResponseOfPtw100InternalServerExceptionToJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionToJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionFromJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionToJSON,
    MaintenanceModeInfoFromJSON,
    MaintenanceModeInfoToJSON,
    SystemInfoDtoFromJSON,
    SystemInfoDtoToJSON,
} from '../models/index';

export interface EnableMaintenanceModeInfoRequest {
    enableMaintenanceModeRequestDto?: EnableMaintenanceModeRequestDto;
}

/**
 * 
 */
export class SystemApi extends runtime.BaseAPI {

    /**
     * Disables the maintenance mode.
     */
    async disableMaintenanceModeInfoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/system/maintenance-mode`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ForbiddenExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ForbiddenException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     * Disables the maintenance mode.
     */
     async disableMaintenanceModeInfo(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<SystemApi['disableMaintenanceModeInfoRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.disableMaintenanceModeInfoRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Enables the maintenance mode.
     */
    async enableMaintenanceModeInfoRaw(requestParameters: EnableMaintenanceModeInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/system/maintenance-mode`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EnableMaintenanceModeRequestDtoToJSON(requestParameters['enableMaintenanceModeRequestDto']),
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 500: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100InternalServerExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100InternalServerException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     * Enables the maintenance mode.
     */
     async enableMaintenanceModeInfo(requestParameters: EnableMaintenanceModeInfoRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<SystemApi['enableMaintenanceModeInfoRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.enableMaintenanceModeInfoRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Returns the current maintenance mode state.
     */
    async getMaintenanceModeInfoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/system/maintenance-mode`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => MaintenanceModeInfoFromJSON(jsonValue), "MaintenanceModeInfo" as const);
					}
          case 204: { 
							return new runtime.VoidApiResponse(response);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => MaintenanceModeInfoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Returns the current maintenance mode state.
     */
     async getMaintenanceModeInfo(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<SystemApi['getMaintenanceModeInfoRaw']>>, MaintenanceModeInfo>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = MaintenanceModeInfo;

         const response = this.getMaintenanceModeInfoRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Returns general information about the system.
     */
    async getSystemInfoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/system`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => SystemInfoDtoFromJSON(jsonValue), "SystemInfoDto" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => SystemInfoDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Returns general information about the system.
     */
     async getSystemInfo(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<SystemApi['getSystemInfoRaw']>>, SystemInfoDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = SystemInfoDto;

         const response = this.getSystemInfoRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Checks whether the server is reachable.
     */
    async pingRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/system/ping`,
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     * Checks whether the server is reachable.
     */
     async ping(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<SystemApi['pingRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.pingRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

}
